// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sr2Oif2yj4LQ33 {
  margin: var(--ds-space-0, 0) -12px;
  padding: var(--ds-space-0, 0);
  border: none;
}

.Sr2Oif2yj4LQ33 .qgWkgcf9IpHZLx {
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  font-weight: var(--ds-font-weight-semibold, 600);
  line-height: 16px;
}

.vM0xYIW6W1_9Ms {
  padding: var(--ds-space-0, 0);
  border: none;
}

.vM0xYIW6W1_9Ms .qgWkgcf9IpHZLx {
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  color: var(--ds-text, #292a2e);
  font-size: 14px;
  font-weight: var(--ds-font-weight-bold, 653);
  line-height: 20px;
}

.ovpwLPjLtvWvek {
  box-sizing: border-box;
  width: 100%;
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  cursor: pointer;
  display: flex;
}

.ovpwLPjLtvWvek:hover {
  background: var(--ds-background-neutral-subtle-hovered, #091e420f);
  color: var(--ds-text, #172b4d);
}

.ovpwLPjLtvWvek:has(.V9Ya18FGBrG6F1:focus-visible) {
  outline: var(--ds-border-width-focused, 2px) solid var(--ds-border-focused, #388bff);
  outline-offset: 2px;
  outline-offset: -1px;
}

.mac .ovpwLPjLtvWvek:has(.V9Ya18FGBrG6F1:focus-visible) {
  outline-color: -webkit-focus-ring-color;
}

.ovpwLPjLtvWvek:has(.V9Ya18FGBrG6F1:focus-visible) .mac.firefox {
  outline-color: accentcolor;
}

.ovpwLPjLtvWvek.nsM5GHLyYCdhyx {
  cursor: not-allowed;
  background: none;
  color: var(--ds-text-disabled, #091e424f) !important;
}

.ovpwLPjLtvWvek .V9Ya18FGBrG6F1 {
  opacity: 0;
  display: block;
  position: absolute;
}

.ovpwLPjLtvWvek .T2dlFMaYEFdZF2 {
  opacity: 0;
  flex: none;
}

.ovpwLPjLtvWvek .V9Ya18FGBrG6F1:checked ~ .T2dlFMaYEFdZF2 {
  opacity: 1;
}
`, ""]);
// Exports
export var radioGroup = `Sr2Oif2yj4LQ33`;
export var legend = `qgWkgcf9IpHZLx`;
export var radioSubGroup = `vM0xYIW6W1_9Ms`;
export var radio = `ovpwLPjLtvWvek`;
export var input = `V9Ya18FGBrG6F1`;
export var disabled = `nsM5GHLyYCdhyx`;
export var icon = `T2dlFMaYEFdZF2`;
export default ___CSS_LOADER_EXPORT___;
